import GroupType from './enums/GroupType'
import Networks from './enums/Networks'

export default function(store, { host }) {
  const Conversation = store.defineModel('conversation', {
    instanceEvents: true,

    transientAttrs: [
      '_counterPartyAddedOnServer',
      '_origIndex',
      'highestSortNumber',
      'unreadCount',
      'unreadPriorityCount',
    ],

    defaultValues: {
      _unreadMessages: null,
      _unreadPriorityMessages: null,
      _markingAsRead: false,
      _markingAsReadSortNumber: null,
      _markingAsReadExpiration: null,
      firstExpiringUnreadMessage: null,
      firstUnreadMessage: null,
      higherContinuation: null,
      highestSortNumber: 0,
      inProgressEscalationCount: 0,
      isLive: false,
      lastBangMessageSortNumber: 0,
      lastIncomingMessageSortNumber: 0,
      lastMessage: null,
      lowerContinuation: null,
      markableAsReadMessages: null,
      messages: null,
      muted: null,
      network: Networks.PROVIDER,
      timeline: null,
      unreadCount: 0,
      unreadPriorityCount: 0,
    },

    skipCamelizationForKeys: [
      'muted',
    ],

    parseAttrs(attrs) {
      if ('muted' in attrs && attrs.muted) {
        const muteSettings = attrs.muted
        if (Object.keys(muteSettings).length > 0) {
          let {
            mute_duration: durationInMinutes,
            mute_start: startedAt,
          } = muteSettings

          if (startedAt) {
            startedAt = +startedAt * 1000
          }
          const muted = host.mute._addEntry(attrs.id, {
            durationInMinutes,
            organizationId: attrs.organizationId,
            startedAt,
          })

          attrs.muted = muted
        } else {
          attrs.muted = null
        }
      }

      return attrs
    },

    afterAssignment(entity) {
      let {
        counterParty,
        counterPartyId,
        counterPartyType,
        id,
        isDeletable,
        isMuteable,
        metadata,
        muted,
        organizationId,
      } = entity

      if (!store.host.config.condensedReplays) {
        muted = host.mute._getByConversationHandle(id)
      } else if (!muted) {
        muted = host.mute.getById(id)
      }

      entity.muted = muted
      entity.isMuted = !!entity.muted

      if (counterParty) {
        counterPartyId = counterParty.id
        counterPartyType = counterParty.$entityType
      } else {
        counterParty = counterPartyType && counterPartyId ? (
          store.store.get(counterPartyType, counterPartyId)
        ) : null
      }

      entity.counterParty = counterParty
      entity.counterPartyId = counterPartyId
      entity.counterPartyType = counterPartyType
      entity.shouldDisplay = !(counterPartyType === 'user' && counterParty && !counterParty.shouldDisplay)

      host.conversations._setAllowedSenders(entity)

      isDeletable = true
      isMuteable = counterPartyType !== 'distributionList'
      if (counterParty && counterPartyType === 'group') {
        const { groupType, p2pSender } = counterParty
        if (groupType === GroupType.ROLE_P2P) {
          const onDuty = p2pSender && p2pSender.$entityType === 'role'
          isDeletable = entity.allowedSenders.length > 0 && !onDuty
          isMuteable = isMuteable && entity.allowedSenders.length > 0
        } else if (groupType === GroupType.ESCALATION) {
          isDeletable = false
          isMuteable = true
        } else if (groupType === GroupType.PATIENT_MESSAGING) {
          isDeletable = entity.counterParty.memberCount > 2
        }
      }

      entity.isDeletable = isDeletable
      entity.isMuteable = isMuteable
      if (!entity._unreadMessages) entity._unreadMessages = []
      if (!entity._unreadPriorityMessages) entity._unreadPriorityMessages = []
      if (!entity.markableAsReadMessages) entity.markableAsReadMessages = []
      if (!entity.messages) entity.messages = []
      if (!entity.timeline) entity.timeline = []
      if (!entity.higherContinuation) {
        entity.higherContinuation = {
          continuation: store.host.config.condensedReplays ? { higher_continuation: null } : 'HIGHER',
          itemsEstimate: null,
        }
      }
      if (!entity.lowerContinuation) {
        entity.lowerContinuation = {
          continuation: store.host.config.condensedReplays ? { lower_continuation: null } : 'LOWER',
          itemsEstimate: null,
        }
      }

      if (metadata && metadata['feature_service'] === 'patient_messaging') {
        entity.network = Networks.PATIENT
        host.users.find(metadata['patient_id'], { organizationId })
      }
    },

    relations: {
      belongsTo: {
        organization: { type: 'organization', foreignKey: 'organizationId' }
      },
      hasMany: {
        content: {
          type: 'message', foreignKey: 'conversationId',
          sortBy: [['sortNumber', 'asc']],
        },
      },
    },
  })

  return Conversation
}
